export const services = [
  {
    slug: "container-destuffing",
    title: "Container Destuffing",
    summary: "Reliable crews unload floor-loaded import containers, sort goods, inspect visible damage, and stage freight for the next move.",
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1200&q=80",
    bullets: ["20 ft, 40 ft, and high-cube containers", "SKU sorting and count support", "Clean handoff to warehouse teams"],
  },
  {
    slug: "lumping-crews",
    title: "Lumping Crews",
    summary: "Flexible labor support for docks, warehouses, reloads, reworks, and seasonal inbound spikes.",
    image: "https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?auto=format&fit=crop&w=1200&q=80",
    bullets: ["Scheduled or on-call crews", "Dock safety discipline", "Supervisor-led daily reporting"],
  },
  {
    slug: "palletizing-wrapping",
    title: "Palletizing and Wrapping",
    summary: "Freight is built into stable pallets, wrapped, labelled, and prepared for storage, dispatch, or cross-dock transfer.",
    image: "https://images.unsplash.com/photo-1601598851547-4302969d0614?auto=format&fit=crop&w=1200&q=80",
    bullets: ["Pallet build standards", "Shrink wrapping and labelling", "Mixed-load sorting"],
  },
  {
    slug: "cross-docking",
    title: "Cross-Docking Support",
    summary: "Hands-on dock teams move freight quickly from container or trailer to outbound staging with minimal dwell time.",
    image: "https://images.unsplash.com/photo-1565891741441-64926e441838?auto=format&fit=crop&w=1200&q=80",
    bullets: ["Inbound to outbound staging", "Load rework and restacking", "Carrier-ready presentation"],
  },
];

export const industries = ["Importers", "3PL warehouses", "Retail distribution", "Food and packaged goods", "E-commerce fulfillment", "Manufacturing supply chains"];
export const serviceAreas = ["Toronto", "Mississauga", "Brampton", "Vaughan", "Markham", "Scarborough", "Hamilton", "Kitchener-Waterloo", "GTA and Southern Ontario"];
